<template>
  <div>
    <el-dialog :visible.sync="visible" width="1260px" title="直播福袋" append-to-body :close-on-click-modal="false" custom-class="live-luckybag-dialog">
      <div class="dialog-content-wrapper">
        <el-button type="primary" @click="handleCreate" size="small" round>+ 添加福袋</el-button>
        <div class="table-wrapper">
          <el-table :data="list" v-loading="listLoading" style="width: 100%; margin-top: 20px;" max-height="500">
            <el-table-column prop="type" label="福袋类型" fixed="left">
          <template slot-scope="{row}">
            <span v-if="row.type === 1">商品福袋</span>
            <span v-else-if="row.type === 2">零售价福袋</span>
            <span v-else>-</span>
            </template>
            </el-table-column>
            <el-table-column prop="getType" label="抽奖分配" fixed="left">
              <template slot-scope="{row}">
                <span v-if="row.getType === 1">随机</span>
                <span v-else-if="row.getType === 2">指定人中奖</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalUserCount" label="是否重复中奖" fixed="left">
              <template slot-scope="{row}">
                <span v-if="row.isCanRepeatWinning&&row.getType === 1">是</span>
                <span v-else-if="!row.isCanRepeatWinning&&row.getType === 1">否</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="levelIdsWinning" label="抽奖权限">
              <template slot-scope="{row}">
                <span v-if="row.levelIdsWinning">{{ formatLevelIdsWinning(row.levelIdsWinning) }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="goodsName" label="商品">
              <template slot-scope="{row}">
                <span v-if="row.type === 1 && row.items && row.items.length > 0 && row.items[0].goodsInfo && row.items[0].goodsInfo.name">
                  {{ row.items[0].goodsInfo.name }}
                </span>
                <span v-else-if="row.type === 1 && row.items && row.items.length > 0 && row.items[0].goodsInfo && (row.items[0].goodsInfo.spec || '无规格值')">
                  {{ row.items[0].goodsInfo.spec || '无规格值' }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalUserCount" label="中奖名额">
              <template slot-scope="{row}">
                <span v-if="row.getType === 1">{{ row.totalUserCount == null ? '-' : row.totalUserCount }}</span>
                <span v-else-if="row.getType === 2 && Array.isArray(row.items)">{{ row.items.length }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalXdbAmount" label="零售价中奖总额" />
            <!-- <el-table-column prop="totalUserCount" label="中奖名额" />
            <el-table-column prop="items.xdbAmount" label="中奖金额">
              <template slot-scope="{row}">
                <span v-if="row.items && row.items.length > 0 && row.items[0].xdbAmount">{{ row.items[0].xdbAmount }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column> -->

            <el-table-column prop="totalXdbAmount" label="奖品明细">
              <template slot-scope="{row}">
                <el-link type="primary" v-if=" row.items && row.items.length > 0" @click="handleViewAmountDetail(row)">查看详情</el-link>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间">
              <template slot-scope="{row}">
                <span>{{ row.createdTime}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="lookTime" label="抽奖门槛">
              <template slot-scope="{row}">
                <span v-if="row.lookTime">{{ row.lookTime>0?row.lookTime+'分钟':'不设置' }}</span>
                <span v-else>不设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="startTime" label="抽奖时间">
              <template slot-scope="{row}">
                <span v-if="row.startTime">{{ row.startTime }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="drawFewMinuteStart" label="开奖时间">
              <template slot-scope="{row}">
                <span v-if="row.drawFewMinuteStart && row.startTime">{{row.drawFewMinuteStart}}分钟{{ dayjs(row.startTime).add(row.drawFewMinuteStart, 'minute') | formatDate }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="blessings" label="开奖口令" />
            <el-table-column prop="status" label="状态">
              <template slot-scope="{row}">
                <el-tag v-if="row.status === 10" type="info">未开始</el-tag>
                <el-tag v-else-if="row.status === 20" type="warning">抽奖中</el-tag>
                <el-tag v-else-if="row.status === 30" type="success">已抽奖</el-tag>
                <el-tag v-else-if="row.status === 40" type="danger">已取消</el-tag>
                <el-tag v-else type="info">-</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="downTime" label="结束时间">
              <template slot-scope="{row}">
                <span v-if="row.startTime && row.drawFewMinuteStart">{{ dayjs(row.startTime).add(row.drawFewMinuteStart, 'minute').format('YYYY-MM-DD HH:mm:ss') }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="{row}">
            <el-link type="primary" v-if="Number(row.status) === 10" @click="handleDown(row)"> 取消福袋 </el-link>
            <el-link type="info" v-if="Number(row.status) === 10" @click="handleUpdate(row)"> 修改 </el-link>
            <el-link type="info" v-if="Number(row.status) === 10" @click="handleUpdate(row)"> 福袋推送IM </el-link>
            <el-link type="danger" @click="handleBuy(row)">抽奖记录</el-link>
          </template>
        </el-table-column>
      </el-table>
        </div>
        <pagination v-show="total > 0" :total="total" :page.sync="query.pageNo" :limit.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-dialog>
    <add-lucky-bag-vue v-if="editorMounted" ref="addLuckyBagVue" @created="doQueryList({})" :liveId="rowItem && rowItem.livePO && rowItem.livePO.id" />
    
    <!-- 抽奖明细弹窗 -->
    <el-dialog :visible.sync="recordVisible" width="1200px" title="抽奖明细" append-to-body :close-on-click-modal="false">
      <div class="filter-container">
        <el-form :model="recordQuery" ref="recordQueryForm" :inline="true">
          <el-form-item label="抽奖人信息：">
            <el-input
              v-model="recordQuery.keywords"
              placeholder="请输入姓名/手机号"
              clearable
              size="small"
              style="width: 200px;"
            />
          </el-form-item>
          <el-form-item label="中奖状态：">
            <el-select
              v-model="recordQuery.status"
              placeholder="全部"
              clearable
              size="small"
              style="width: 150px;"
            >
              <el-option label="已报名" :value="0"></el-option>
              <el-option label="中奖" :value="1"></el-option>
              <el-option label="未中奖" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleRecordQuery" size="mini">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 统计信息 -->
      <div class="statistics-info" style="color: #f56c6c; margin: 10px 0;">
        参与人数: {{ recordTotal || 0 }}、中奖人数: {{ statisticsInfo.winCount || 0 }}
      </div>
      <el-table :data="recordList" v-loading="recordLoading" style="width: 100%; margin-top: 20px;">
        <el-table-column label="抽奖人信息" align="center">
          <template slot-scope="{row}">
            <span>{{ formatUserInfo(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="参与时间" align="center">
          <template slot-scope="{row}">
            <span>{{ row.createdTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="中奖状态" align="center">
          <template slot-scope="{row}">
            <span v-if="row.state === 0">已报名</span>
            <span style="color: #f56c6c;" v-else-if="row.state === 1">中奖</span>
            <span v-else-if="row.state === 2">未中奖</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="中奖明细" align="center">
          <template slot-scope="{row}">
            <span v-if="row.state === 1">
              <span v-if="row.winning && row.winning.xdbAmount">{{ row.winning.xdbAmount }}零售价</span>
              <span v-else-if="row.winning && row.winning.goodsInfo">
                <span v-if="row.winning.goodsInfo.name">{{ row.winning.goodsInfo.name }}</span>
                <span v-if="(row.winning.goodsInfo.spec || '无规格值') && (row.winning.goodsInfo.spec || '无规格值') !== row.winning.goodsInfo.name">
                  {{ row.winning.goodsInfo.name ? '+' : '' }}{{ row.winning.goodsInfo.spec || '无规格值' }}
                </span>
              </span>
              <span v-else>-</span>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination 
        v-show="recordTotal > 0" 
        :total="recordTotal" 
        :page.sync="recordQuery.pageNo" 
        :limit.sync="recordQuery.pageSize" 
        @pagination="doQueryRecordList" 
      />
    </el-dialog>

    <!-- 中奖金额详情弹窗 -->
    <el-dialog :visible.sync="amountDetailVisible" width="800px" title="奖品明细" append-to-body :close-on-click-modal="false">
      <el-table :data="amountDetailList" v-loading="amountDetailLoading" style="width: 100%;">
        <el-table-column prop="designatedUserId" label="指定人用户id" align="center" v-if="currentDetailGetType === 2">
          <template slot-scope="{row}">
            <span>{{ row.designatedUserId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" align="center" v-if="currentDetailType === 1">
          <template slot-scope="{row}">
            <span>{{ row.goodsName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="xdbAmount" label="中奖零售价" align="center" v-if="currentDetailType === 2">
          <template slot-scope="{row}">
            <span>{{ row.xdbAmount || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalCount" label="中奖名额" align="center">
          <template slot-scope="{row}">
            <span>{{ row.totalCount || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import liveBlessingBagApi from '@/api/live/liveBlessingBag'
import liveBlessingBagSignUpApi from '@/api/live/liveBlessingBagSignUp'
import liveManageApi from '@/api/live/liveManage'
import addLuckyBagVue from './addLuckyBag.vue'  
import Pagination from '@/components/Pagination'
import { formatDate as formatDateUtil } from '@/utils/dateTime'
export default {
  components: {
    addLuckyBagVue,
    Pagination
  },
  filters: {
    formatDate(value) {
      if (!value) return '-'
      return formatDateUtil(value)
    }
  },
  data() {
    return {
      visible: false,
      formVisible: false,
      editorMounted: false,
      adminList: [],
      form: {
        admin: ''
      },
      adminOptions: [],
      modelType: 1,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      list: [],
      identityNames: {},
      total: 0,
      rowItem: null,
      listLoading: false,
      // 抽奖记录相关
      recordVisible: false,
      recordList: [],
      recordTotal: 0,
      recordLoading: false,
      recordQuery: {
        blessingBagId: null,
        keywords: '',
        status: null,
        pageNo: 1,
        pageSize: 10
      },
      currentBagId: null,
      statisticsInfo: {
        totalCount: 0,
        winCount: 0
      },
      // 中奖金额详情相关
      amountDetailVisible: false,
      amountDetailList: [],
      amountDetailLoading: false,
      currentDetailType: null, // 当前查看详情的福袋类型
      currentDetailGetType: null // 当前查看详情的抽奖分配类型
    }
  },
  methods: {
    handleCreate() {
      this.editorMounted = true
      this.$nextTick(() => this.$refs.addLuckyBagVue.handleCreate())
    },
    handleUpdate(row) {
      this.editorMounted = true
      this.$nextTick(() => this.$refs.addLuckyBagVue.handleUpdate(row))
    },
    handleShow(row) {
      this.rowItem = row
      this.loadIdentityNames()
      // 只重置页码为1，保持上次的每页条数不变
      this.doQueryList({ pageNo: 1 })
      this.visible = true
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.createdTimeSortSign=-1;
      this.listLoading = true
      return liveBlessingBagApi.fetchList({ ...this.query, liveId: this.rowItem && this.rowItem.livePO && this.rowItem.livePO.id })
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    showAddDialog() {
      this.modelType = 1
      this.formVisible = true
    },
    handleDown(row) {
      if (!row.id) {
        this.$message.error('缺少福袋ID')
        return
      }
      
      // 确认取消操作
      this.$confirm('确认取消该福袋吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用取消福袋接口
        liveBlessingBagApi.cancel({ id: row.id })
          .then(() => {
            this.$message.success('取消福袋成功')
            // 刷新列表
            this.doQueryList({})
          })
          .catch(err => {
            console.error('取消福袋失败:', err)
            this.$message.error(err.message || '取消福袋失败')
          })
      }).catch(() => {
        // 用户取消操作
      })
    },
    removeAdmin(idx) {
      // 这里写移除逻辑
      this.adminList.splice(idx, 1)
    },
    /**
     * 打开抽奖记录弹窗
     */
    handleBuy(row) {
      if (!row.id) {
        this.$message.error('缺少福袋ID')
        return
      }
      this.currentBagId = row.id
      this.recordQuery.blessingBagId = row.id
      this.recordQuery.pageNo = 1
      this.recordQuery.pageSize = 10
      this.recordQuery.keywords = ''
      this.recordQuery.status = null
      // 重置统计信息，避免显示旧数据
      this.statisticsInfo = {
        totalCount: 0,
        winCount: 0
      }
      this.recordVisible = true
      this.doQueryRecordList({ pageNo: 1, pageSize: 10 })
      this.getStatisticsCount()
    },
    /**
     * 查询抽奖记录列表
     */
    doQueryRecordList({ pageNo, pageSize }) {
      if (pageNo) {
        this.recordQuery.pageNo = pageNo
      }
      if (pageSize) {
        this.recordQuery.pageSize = pageSize
      }
      this.recordLoading = true
      const params = {
        blessingBagId: this.recordQuery.blessingBagId,
        pageNo: this.recordQuery.pageNo,
        pageSize: this.recordQuery.pageSize
      }
      // 如果有搜索关键字，添加 keywords 参数
      if (this.recordQuery.keywords) {
        params.keywords = this.recordQuery.keywords
        params.userType=20
      }
      // 如果有中奖状态，添加 status 参数
      if (this.recordQuery.status !== null && this.recordQuery.status !== undefined && this.recordQuery.status !== '') {
        params.status = this.recordQuery.status
      }
      // 如果有用户类型，添加 userType 参数
      if (this.recordQuery.userType !== null && this.recordQuery.userType !== undefined && this.recordQuery.userType !== '') {
        params.userType = this.recordQuery.userType
      }
      
      return liveBlessingBagSignUpApi.fetchList(params)
        .then(data => {
          this.recordList = data.data.list || []
          this.recordTotal = data.data.total || 0
        })
        .catch(err => {
          console.error('获取抽奖记录失败:', err)
          this.$message.error(err.message || '获取抽奖记录失败')
          this.recordList = []
          this.recordTotal = 0
        })
        .finally(() => {
          this.recordLoading = false
        })
    },
    /**
     * 搜索抽奖记录
     */
    handleRecordQuery() {
      this.doQueryRecordList({ pageNo: 1 })
      this.getStatisticsCount()
    },
    /**
     * 获取统计人数
     */
    getStatisticsCount() {
      if (!this.recordQuery.blessingBagId) {
        return
      }
      const params = {
        blessingBagId: this.recordQuery.blessingBagId
      }
      params.status=1;
      
      liveBlessingBagSignUpApi.getCount(params)
        .then(data => {
          if (data && data.data !== undefined && data.data !== null) {
            this.statisticsInfo = {
              totalCount: 0,
              winCount: data.data || 0
            }
          } else {
            // 如果接口返回的数据格式不正确，重置为0
            this.statisticsInfo = {
              totalCount: 0,
              winCount: 0
            }
          }
        })
        .catch(err => {
          console.error('获取统计人数失败:', err)
          // 失败时重置为0，不显示错误提示，避免影响用户体验
          this.statisticsInfo = {
            totalCount: 0,
            winCount: 0
          }
        })
    },
    /**
     * 重置搜索条件
     */
    handleRecordFilter() {
      this.recordQuery.keywords = ''
      this.recordQuery.userType = null
      this.doQueryRecordList({ pageNo: 1 })
    },
    /**
     * 格式化用户信息显示
     */
    formatUserInfo(row) {
      if (!row) return '-'
      const name = row.userRealName||  ''
      const phone = row.userMobile || ''
      const position = row.userLevelName || ''
      
      if (!name && !phone) return '-'
      
      let result = name || phone
      if (phone && name) {
        result = `${name}（${phone}${position ? '-' + position : ''}）`
      } else if (phone) {
        result = phone
      }
      
      return result
    },
    /**
     * 查看中奖金额详情
     */
    handleViewAmountDetail(row) {
      if (!row || !row.items || row.items.length === 0) {
        this.$message.warning('暂无奖品明细')
        return
      }
      
      this.currentDetailType = row.type
      this.currentDetailGetType = row.getType
      
      // 根据福袋类型处理数据
      if (row.type === 2) {
        // 零售价福袋
        if (row.getType === 2) {
          // 指定人中奖：显示每个用户的详细信息，不分组
          this.amountDetailList = row.items.map(item => ({
            designatedUserId: item.designatedUserId || '-',
            xdbAmount: item.xdbAmount || 0,
            totalCount: item.totalCount || 0
          }))
        } else {
          // 随机中奖：按金额分组统计
          const amountMap = {}
          row.items.forEach(item => {
            const amount = item.xdbAmount || 0
            if (amountMap[amount]) {
              amountMap[amount].totalCount += item.totalCount || 0
            } else {
              amountMap[amount] = {
                xdbAmount: amount,
                totalCount: item.totalCount || 0
              }
            }
          })
          this.amountDetailList = Object.values(amountMap)
        }
      } else if (row.type === 1) {
        // 商品福袋：显示商品信息
        this.amountDetailList = row.items.map(item => ({
          designatedUserId: item.designatedUserId || '-',
          totalCount: item.totalCount || 0,
          goodsName: item.goodsInfo ? (item.goodsInfo.name || item.goodsInfo.spec || '无规格值') : '-'
        }))
      } 
      
      this.amountDetailVisible = true
    },
    // 与创建表单使用同一份客户身份字典，避免写死ID导致名称错位。
    loadIdentityNames() {
      const names = Object.create(null)
      try {
        const levels = JSON.parse(localStorage.getItem('levelList')) || []
        if (Array.isArray(levels)) {
          levels.forEach(level => {
            if (level && level.id != null && typeof level.name === 'string' && level.name.trim()) {
              names[String(level.id)] = level.name
            }
          })
        }
      } catch (_) {
        // 字典不可用时保留原ID，不猜测身份名称。
      }
      this.identityNames = names
    },
    /** 格式化抽奖权限显示，未知身份保留原ID。 */
    formatLevelIdsWinning(levelIdsWinning) {
      if (!levelIdsWinning) return '-'
      
      // 将字符串按逗号分割，转换为数组，然后映射为中文名称
      const ids = String(levelIdsWinning).split(',').map(id => id.trim())
      const names = ids.map(id => this.identityNames[id] || id).filter(name => name)
      
      return names.length > 0 ? names.join('、') : levelIdsWinning
    }
  }
}
</script>
